class AuthManager {
  isAuthing = false;
}
const authManager = new AuthManager();
export { authManager };
